module.exports = "pegasus/assets/themelp1/ebook/103.png";